import React, { Component } from 'react';
import { Row, Col, Form, Input, Card, Icon } from 'antd';

export default class EmailSecurityQuestions extends Component {
    constructor(props) { super(props); }
    render() {
        const
        { state, services } = this.props,
        { securityQuestion1, securityQuestion2, securityQuestion3 } = state.passwordReset;
        return (
            <div>
                <div style={{
                    boxShadow: 'rgb(184, 184, 184) 0px 0px 20px',
                    borderRadius: '10px',
                    borderStyle: 'solid',
                    borderColor: 'rgb(200, 200, 200)',
                    borderWidth: '1px'
                }}>
                    <Card style={{
                        borderRadius: '10px',
                        borderStyle: 'solid',
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: '1px'
                    }}>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <Form.Item
                                    colon={false}
                                    label='In what city were you born?'
                                    required={true}
                                    style={{ width: '300px' }}
                                >
                                    <Input
                                        size='small'
                                        placeholder='City'
                                        prefix={(<Icon type='home' />)}
                                        onChange={e => services.updateResetField(e.target.name, e.target.value)}
                                        value={securityQuestion1}
                                        name='securityQuestion1'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <Form.Item
                                    colon={false}
                                    label='What is your favorite food?'
                                    required={true}
                                    style={{ width: '300px' }}
                                >
                                    <Input
                                        size='small'
                                        placeholder='Food'
                                        prefix={(<Icon type='coffee' />)}
                                        onChange={e => services.updateResetField(e.target.name, e.target.value)}
                                        value={securityQuestion2}
                                        name='securityQuestion2'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <Form.Item
                                    colon={false}
                                    label='What is your favorite color?'
                                    required={true}
                                    style={{ width: '300px' }}
                                >
                                    <Input
                                        size='small'
                                        placeholder='Color'
                                        prefix={(<Icon type='form' />)}
                                        onChange={e => services.updateResetField(e.target.name, e.target.value)}
                                        value={securityQuestion3}
                                        name='securityQuestion3'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        );
    }
}
